module.exports = __webpack_public_path__ + "static/media/516.e7063de2.jpg";